import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Button, Card, CardBody, CardFooter, CardImg, Col } from 'reactstrap'
import { SuitcaseSimple } from "phosphor-react"
import Skeleton from '../UI/Skeleton'

class PartnersCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            link: `/project/${this.props.id}`,
            imageLoaded: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
        this.readMore = this.readMore.bind(this)
    }

    readMore(event) {
        event.preventDefault()
        this.props.props.history.push(`/project/${this.props.id}`)
    }

    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <Col sm={12} md={6} lg={6} xl={4} className="catalog-card d-flex align-items-stretch">
                            <Card className="d-flex flex-column partners-card">
                                <Skeleton height={250} className='card-img' image={true} />
                                <CardBody className="project-body">
                                    <div className="card-title project md-font-size"><Skeleton width={'50%'} /></div>
                                    <div className="card-desc project md-font-size"><Skeleton count={5} /></div>
                                </CardBody>
                                <CardFooter className="catalog-card-bottom project mt-auto d-flex justify-content-center">
                                    <Skeleton width={260} button={true} className="btn profile-avatar-btn primary p-10-20px" />
                                </CardFooter>
                            </Card>
                        </Col>
                        :
                        <Col sm={12} md={6} lg={6} xl={4} className="catalog-card d-flex align-items-stretch" id={`item-${this.props.id}`}>
                            <Card className="d-flex flex-column partners-card">
                                {!this.state.imageLoaded && this.props.image && <div className="card-img"><Skeleton height={250} image={true} /></div>}
                                {this.props.image && <CardImg onLoad={() => this.setState({ imageLoaded: true })} src={`${this.state.imageUrl}/${this.props.image}`} alt="" className={this.state.imageLoaded ? '' : ' d-none'} onClick={this.readMore} />}
                                <CardBody className="project-body">
                                    <div className="card-title project md-font-size">{this.props.title}</div>
                                    <div className="card-desc project md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                                </CardBody>
                                <CardFooter className="catalog-card-bottom project mt-auto">
                                    <Button
                                        type="button"
                                        className="btn profile-avatar-btn primary p-10-20px"
                                        onClick={this.readMore}
                                        disabled={!this.props.url}
                                    >
                                        <div className="d-flex align-items-center justify-content-center">
                                            <SuitcaseSimple size={20} color="#ffffff" />
                                            <span className="pl-5px sm-font-size">{t('partners-read-more')}</span>
                                        </div>
                                    </Button>
                                </CardFooter>
                            </Card>
                        </Col>
                }
            </React.Fragment>
        )
    }
}

PartnersCard.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    id: PropTypes.number,
    props: PropTypes.object,
    image: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    tags: PropTypes.array,
    partners: PropTypes.array,
    totalPartners: PropTypes.number,
    likes: PropTypes.number,
    oldPrice: PropTypes.number,
    newPrice: PropTypes.number,
    url: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default withTranslation()(PartnersCard)



// WEBPACK FOOTER //
// ./src/components/Partners/PartnersCard.jsx